{
  "name": "benzaiten",
  "version": "0.0.09-BETA",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "build:uat": "ng build --configuration uat",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "overrides": {
    "sass": "1.100.0"
  },
  "dependencies": {
    "@angular/animations": "^20.3.7",
    "@angular/cdk": "^20.2.10",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@coreui/angular": "~5.5.17",
    "@coreui/angular-chartjs": "~5.5.17",
    "@coreui/chartjs": "^4.0.0",
    "@coreui/coreui": "^5.4.3",
    "@coreui/icons": "^3.0.1",
    "@coreui/icons-angular": "~5.5.17",
    "@faker-js/faker": "^10.1.0",
    "@katoid/angular-grid-layout": "^3.1.0",
    "@optima-stride-ai/core": "^0.0.74",
    "@optima-stride-ai/optima-app-framework": "^0.0.160",
    "@optima-stride-ai/optima-components": "^0.61.17-alpha.0",
    "@optima-stride-ai/optima-platform": "^0.0.48",
    "@primeuix/themes": "^1.2.5",
    "angular-split": "^20.0.0",
    "browser-image-compression": "^2.0.2",
    "chart.js": "^4.5.1",
    "chartjs": "^0.3.24",
    "chartjs-plugin-trendline": "^3.1.1",
    "d3": "^7.9.0",
    "d3-org-chart": "^3.1.1",
    "easymde": "^2.20.0",
    "fabric": "^6.9.1",
    "jszip": "^3.10.1",
    "lib0": "^0.2.117",
    "marked": "^17.0.1",
    "mathjs": "^14.9.1",
    "ngx-editor": "^19.0.0-beta.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.3",
    "tslib": "^2.3.0",
    "turndown": "^7.2.2",
    "turndown-plugin-gfm": "^1.0.2",
    "y-websocket": "^3.0.0",
    "yjs": "^13.6.31",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/schematics": "^20.4.0",
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.0.6",
    "@angular/compiler-cli": "^20.3.0",
    "@types/chartjs-plugin-trendline": "^1.0.4",
    "@types/d3-org-chart": "^3.1.2",
    "@types/jasmine": "~5.1.0",
    "@types/turndown": "^5.0.6",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "3.6.2",
    "typescript": "~5.9.2"
  }
}
